import type GroupMember from 'bundles/authoring/groups/models/GroupMember';

export default function getAnonymizedName(learner: GroupMember, isAnonymized?: boolean | null) {
  return typeof learner.getDisplayName === 'function' ? learner.getDisplayName(isAnonymized) : learner.fullName;
}
